import { Button, Card, CardBody, Row, Col } from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import Image from "../../assets/img/sidebar-login.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useApi from "../../apiHooks/apiHooks";
import displayToast from "functions/displayToast";

const ResetPassword = () => {
    const history = useHistory();
    const { token } = useParams();
    const { resetPassword } = useApi();

    const initialValues = {
        password: "",
        confirmPassword: "",
    };

    const validationSchema = Yup.object({
        password: Yup.string()
            .min(8, "Password must be at least 8 characters")
            .required("Password is required"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwords must match")
            .required("Confirm Password is required"),
    });

    const onSubmit = async (values, { setSubmitting }) => {
        try {
            await resetPassword({
                token,
                password: values.password,
            });
            displayToast("success", "Password reset successfully");
            history.push("/");
        } catch (err) {
            const error = err.response;
            displayToast(
                "error",
                error?.data?.error || "Password could not be reset"
            );
        } finally {
            setSubmitting(false);
        }
    };

    const styles = {
        inputContainer: {
            display: "flex",
            flexDirection: "column",
        },
    };

    return (
        <div style={{ overflow: "hidden" }}>
            <Row>
                <Col
                    lg="4"
                    md="7"
                    style={{
                        paddingRight: 0,
                        paddingLeft: 0,
                        height: "100vh",
                    }}
                >
                    <Card
                        className="bg-white"
                        style={{
                            width: "100%",
                            height: "100%",
                            background: `url(${Image})`,
                            backgroundSize: "cover",
                        }}
                    >
                        <CardBody className="px-lg-6 py-lg-7">
                            <h1
                                style={{ color: "#F8F8F8", fontSize: 35 }}
                                className="text-white"
                            >
                                GTOaas
                            </h1>
                            <h4
                                style={{ color: "#F8F8F8", fontSize: 15 }}
                                className="text-white"
                            >
                                PASSWORD RESET
                            </h4>
                        </CardBody>
                    </Card>
                </Col>
                <Col lg="8" md="7" style={{ paddingRight: 0, paddingLeft: 0 }}>
                    <Card
                        className="bg-white"
                        style={{
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <CardBody
                            className="px-lg-8 py-lg-7"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}
                        >
                            <h1>Reset Password</h1>
                            <div className="text-muted mb-4">
                                <h4>Enter a new password for your account</h4>
                            </div>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                            >
                                {(formik) => (
                                    <Form>
                                        <div
                                            className="mt-5"
                                            style={styles.inputContainer}
                                        >
                                            <label htmlFor="password">
                                                New Password
                                            </label>
                                            <Field
                                                name="password"
                                                id="password"
                                                type="password"
                                                disabled={formik.isSubmitting}
                                                style={{ padding: "0.75rem" }}
                                            />
                                            <ErrorMessage
                                                component="div"
                                                className="red-text"
                                                name="password"
                                            />
                                        </div>
                                        <div
                                            className="mt-5"
                                            style={styles.inputContainer}
                                        >
                                            <label htmlFor="confirmPassword">
                                                Confirm Password
                                            </label>
                                            <Field
                                                name="confirmPassword"
                                                id="confirmPassword"
                                                type="password"
                                                disabled={formik.isSubmitting}
                                                style={{ padding: "0.75rem" }}
                                            />
                                            <ErrorMessage
                                                component="div"
                                                className="red-text"
                                                name="confirmPassword"
                                            />
                                        </div>
                                        <Button
                                            disabled={formik.isSubmitting}
                                            style={{
                                                display: "block",
                                                width: "100%",
                                            }}
                                            className="mt-5"
                                            color="default"
                                            type="submit"
                                        >
                                            Reset Password
                                        </Button>
                                        <Link className="d-block mt-3" to="/">
                                            Back to login
                                        </Link>
                                    </Form>
                                )}
                            </Formik>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ResetPassword;
